import React from 'react'

const Footer = () => {
  return (
    <footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <p class="text-muted small mb-4 mb-lg-0">ComSept - Simplifying data management. &copy; 2024 ComSept. All rights reserved.</p>
            </div>
        </div>
    </div>
</footer>

  )
}

export default Footer